import Icons from '../../icons';

export default function Features() {
    const features = [
        /*{
            title: 'Create Tournaments',
            description: 'Create your own tournaments and invite your friends to compete.',
            icon: 'trophy',
            color: 'blue',
        },*/
        {
            title: 'Create Teams',
            description: 'Create teams and invite your friends to join.',
            icon: 'users',
            color: 'red',
        },
        {
            title: 'Watch Live Matches',
            description: 'Watch live matches from your friends and favorite teams.',
            icon: 'twitch',
            color: 'purple',
        },
        {
            title: 'Todo List',
            description: 'Create a todo list for your team and manage your tasks.',
            icon: 'todo',
            color: 'green',
        },
        {
            title: 'Voice Chat',
            description: 'Join voice channels and talk with your friends while playing.',
            icon: 'volume',
            color: 'yellow',
        }
    ];

    const gradient = (color: string) => {
        return `bg-gradient-to-br from-${color}-400 to-${color}-600`;
    }
        
        
    return (
        <div className="bg-brand-darkest mt-64 sm:-ml-4 sm:-mr-4  max-w-screen">
            <div className="px-2 sm:px-32 py-16">
                <h1 className="text-white text-4xl font-bold text-center">Features</h1>
                <p className="text-gray-300 text-center mt-4">
                    Teamly offers a wide range of features to help you manage your team and tournaments.
                </p>

                <div className="grid grid-cols-2 mt-6 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="flex flex-col items-center gap-4">
                            <div className={`p-4 rounded-lg ${gradient(feature.color)} flex items-center justify-center`}>
                                <Icons name={feature.icon} size='36' color="white" />
                            </div>
                            <h2 className="text-white text-lg font-semibold text-center">{feature.title}</h2>
                            <p className="text-gray-300 text-center">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
